import { combineEpics } from "redux-observable";
import fetchUserCasesEpic from "./epic_allCaseData";
import fetchUserDataEpic from "./epic_userData";
import fetchReferenceDataEpic from "./epic_reference";
import fetchICertCasesEpic from "../../../components/PWDCasesSearch/CERTCasesSearch/epic/epics";

export default combineEpics(
  fetchUserCasesEpic,
  fetchUserDataEpic,
  fetchReferenceDataEpic,
  fetchICertCasesEpic
);
